import { v4 as uuidv4 } from "uuid";
export class ClockWorkEntryModel {
    constructor() {
        this.id = uuidv4();
        this.startTime = null;
        this.endTime = null;
        this.description = "";
        this.employeeId = null;
        this.startTimeTzFormatted = "";
        this.endTimeTzFormatted = "";
        this.totalTime = "";
        this.totalTimeInSeconds = 0;
        this.timeSinceMidNightInMinutes = 0;
        this.projectDisplayString = "";
        this.taskDisplayString = "";
        this.upFillApplicable = false;
        this.downFillApplicable = false;
        this.upFillHover = "";
        this.downFillHover = "";
        this.projectId = "";
        this.entryAtWork = false;
        this.isMember = false;
    }
    isEntrySplittable() {
        let start = new Date(this.startTime).getTime();
        let end = new Date(this.endTime).getTime();
        let timeDifference = Math.floor((end - start) / 1000 / 60);
        if (timeDifference == 0 || timeDifference <= 2 || this.endTimeTzFormatted == "now") {
            return true;
        }
        return false;
    }
}
export default class ClockWorkEntry extends ClockWorkEntryModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
